<template>	
	<div>
		<div class="condition">
			<div class="search_wrap">
				<el-form :inline="true" :model="formdata" class="form-inline">
					<el-form-item label="核销码">
						<el-input v-model="formdata.code" placeholder="请输入核销码" class="w200" size="small"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="formdata.mobile" placeholder="请输入手机号" class="w200" size="small"></el-input>
					</el-form-item>
					<el-form-item label="活动名称及奖项">
						<el-cascader
							v-model="activedata"
							size="small"
							:options="activity_list"
							:props="{value: 'id', label: 'name', children: 'prize',	expandTrigger: 'hover'}"
							@change="handleChange"></el-cascader>
					</el-form-item>
					<el-form-item label="中奖时间">
						<el-date-picker
							v-model="timeData"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="核销状态">
						<el-select class="mr10 w130" size="small" v-model="formdata.status" placeholder="请选择核销状态">
							<el-option label="全部"  :value="0"></el-option>
							<el-option label="已核销" :value="2"></el-option>
							<el-option label="未核销" :value="1"></el-option>
						</el-select>              
					</el-form-item>
					<el-form-item label="用户昵称">
						<el-input v-model="formdata.nickname" placeholder="请输入用户昵称" class="w200" size="small"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
						<el-button type="primary"  size="small" @click="excelOut">导出</el-button>
						<a ref="download" v-show="false" :href="downloadUrl" :download="downloadfilename"></a>
					</el-form-item>
				</el-form>
			</div>
			<!-- <div class="hexiao-btn"><el-button type="primary" size="small" icon="el-icon-edit"  @click="open()">核销</el-button></div> -->
		</div>
		<div class="table_wrap">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="中奖用户" align="center">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
						<img src="@/assets/imgs/userDefult.png" altwu width="60px" height="60px" v-else/>
						<p>{{scope.row.nickname}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="draw_info_after" label="用户信息">
					<template slot-scope="scope">	
						<p v-for="(itema, index) in scope.row.draw_info_after" :key="index">
							{{itema.explain}}：{{itema.value}}
						</p>
						<el-link v-if="scope.row.draw_info_before.length > 0" type="primary" @click="onShowForm(scope.$index)">抽奖前表单</el-link>
					</template>
				</el-table-column>
				<el-table-column prop="activity_title" label="中奖信息">
					<div slot-scope="scope" >
						<span :title="scope.row.activity_title ">活动名称：{{scope.row.activity_title | ellipsis}}</span>
						<p>中奖奖项：{{scope.row.level_name | ellipsis}}{{scope.row.level_name2}}</p>
						<p>中奖时间：{{scope.row.create_time}}</p>
					</div>
				</el-table-column>
				<el-table-column  label="邀请人" align="center">
					<template slot-scope="scope">
						<img :src="scope.row.invitation_avatar" alt width="60px" height="60px" v-if="scope.row.invitation_avatar"/>
						<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
						<p>{{scope.row.invitation_nickname}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="order_no" label="兑奖信息">
					<div slot-scope="scope">
						<template v-if="scope.row.prize_id == -1">
							"{{scope.row.prize_name}}"无法兑奖
						</template>
						<template v-else>
							<p>核销状态：
								<span v-if="scope.row.verification_status==0" class="red">{{scope.row.verification_text}}</span>
								<span v-if="scope.row.verification_status==1" class="green">{{scope.row.verification_text}}</span>
							</p>
							<p>核销码：{{scope.row.verification_code}}</p>
							<p>兑奖有效时间：{{scope.row.verification_expire_text}}</p>
						</template>
					</div>
				</el-table-column>
				<el-table-column fixed="right" label="操作" align="center">
					<template slot-scope="scope">
						<p>
							<el-button type="primary" size="small" icon="el-icon-edit"  @click="open(scope.row.verification_code)" v-if="scope.row.verification_text=='未核销' && scope.row.prize_id != -1">核销</el-button>
							<el-button type="primary" size="small"  @click="open(scope.row.verification_code)" disabled v-if="scope.row.verification_text=='已核销'">已核销</el-button>
						</p>
						<!-- <p style="margin-top:10px">
							<el-button type="primary" size="small"  @click="ReissueCommission(scope.row.id)"  v-if="scope.row.commission_status==2">重发佣金</el-button>
						</p> -->
					</template>
				</el-table-column> 
			</el-table>
			<div class="pag_wrap">
				<el-pagination
					background
					:page-size="page.page_size"
					:current-page="page.current_page"
					layout="total, prev, pager, next"
					:total="page.total_rows"
					@current-change="pageIndexChange"
				></el-pagination>
			</div>
		</div>
		<afterSalesForm :visible.sync="dialogForm" title="抽奖前表单" :property="payData"></afterSalesForm>
	</div>
</template>

<script>
	import api from "@/api.js";
	import { pagination1 } from "@/util/util.js";
	import afterSalesForm from '@/components/tkdialog/afterSalesForm';
	export default {
		name: 'drawLog',
		components: {
			afterSalesForm
		},
		filters: { // 限制文本显示字数,超出部分用...代替
			ellipsis (value) {
				if (!value) return ''
				if (value.length > 10) {
					return value.slice(0,10) + '...'
				}
				return value
			}
		},
		data() {
		  return {
				activedata: [],
				downloadUrl: '',
				downloadfilename: '',
				dialogForm: false,
				payData: null,
				activity_list: [],
		    formdata: {
					code: '',
					mobile: '',
					activity_id: '',
					prize_id: '',
					start_time: '',
					end_time: '',
					status: '',
					nickname: '',
					page: 1,
					is_excel_out: 0
		    },
		    timeData: [],
		    tableData: [],
				page: {
					current_page: pagination1.current_page,
					page_size: pagination1.page_size,
					total_rows: pagination1.total_rows
				},
		    pickerOptions1: {
		      disabledDate(time) {
		        return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
		      }
		    }
		  };
		},
		created() {
		  this.init();
		},
		methods: {
			handleChange(value) {
				this.formdata.activity_id = value[0];
				this.formdata.prize_id = value[1];
      },
		  //初始化请求
		  init() {
		    this.querycustom();
			},
		  // 查询
		  querycustom() {
		    if (this.timeData && this.timeData.length > 0) {
		      this.formdata.start_time = this.timeData[0]
		      this.formdata.end_time = this.timeData[1]
		    } else {
		      this.formdata.start_time = "";
		      this.formdata.end_time = "";
		    }
		    this.axios
					.post(api.getDrawLog, this.formdata)
					.then(response => {
						if (response.data.code == 0) {
							this.activity_list  = response.data.result.activity_list;
							this.tableData = response.data.result.list;
							this.page = response.data.page;
						} 
					})
					.catch(() => {});
			},
		  searchcustomer() {
		    this.formdata.page = 1;
		    this.querycustom();
		  },
		  pageIndexChange(pageindex) {
		    this.formdata.page = pageindex;
		    this.querycustom();
			},
			onShowForm(option) {
				this.payData = this.tableData[option].draw_info_before;			
				this.dialogForm = true;
			},
			//核销弹框
			open(value) {
				this.$confirm('是否确定核销?（核销码：'+ value +'）', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
				.then(() => {
					this.axios
						.post(api.checkDrawCode, {code: value})
						.then(res => {
							if (res.data.code == 0) {
								this.$message.success(res.data.msg);
								this.querycustom();
							} 
						}).catch(res => {});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消核销'
          });       
        });
			},
			//导出excel
			excelOut(){
			  this.$confirm('是否确认导出Excel?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
					this.formdata.is_excel_out = 1
					this.axios
						.post(api.getDrawLog, this.formdata)
						.then(res=>{
							if(res.data.code == 0 && res.data.result.excel_data !=''){
								this.downloadUrl = res.data.result.excel_data;
								this.downloadfilename = res.data.result.excel_filename;
								setTimeout(() => {
									this.$refs.download.click()
								}, 200)
							}
						})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });          
        });
			}
		}
	}
</script>

<style scoped>
.condition .el-form-item{margin-bottom: 10px;}
.green{color: #29A7F4; background-color: transparent;}
</style>